export const formatCalendarDate = (value, month = "short") => {
  if (!value) return "—";
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return String(value);
  const [, year, monthNumber, day] = match;
  const date = new Date(Date.UTC(Number(year), Number(monthNumber) - 1, Number(day)));
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat("id-ID", {
    day: "2-digit",
    month,
    year: "numeric",
    timeZone: "UTC",
  }).format(date);
};